<template>
  <div>
    <div v-if="exclusiveUser && exclusiveDetails && exclusiveDetails.expire_in >= 0">
      <div class="exmembership-wrapper">
        <div class="exmembership-header">
          <h3>THE SOULED STORE</h3>
          <h2>MEMBERSHIP</h2>
        </div>
        <div class="exmembership-content">
          <div class="exmembership-heading">
              <h3>{{user && user.firstname}} <span v-if="user && user.lastname !== 'None'">{{user.lastname}}</span></h3>
              <h4>
                Membership valid till {{exclusiveDetails.expiry_date}}
              </h4>
          </div>
          <div v-if="isSelectedCountryIndia" class="exmembership-saving">
            <h4>
              Savings so far
            </h4>
            <h3 class="d-flex align-items-center justify-content-center">
              <sup>{{ currencySymbol }}</sup>
              <span v-for="digit in exclusiveDetails.exclusive_savings.toString()" :key="digit">{{digit}}</span>
            </h3>
          </div>
          <div v-if="isSelectedCountryIndia" class="exmembership-saving-heading">
            <h5>
              This is {{formatTimesResult}} times what you have paid for
            </h5>
            <h4>
              The Souled Store Membership
            </h4>
          </div>
          <div class="exmembership-day-left">
            <div class="exmembership-day-inner">
              <circle-counter 
                size="10rem" 
                :dash-spacing="0"
                :stroke-width="8"
                :active-width="8"
                :dash-count="100"
                :stroke="parseInt(exclusiveDetails.expire_in) === parseInt(exclusiveDetails.expire_days) ? '#333333' : '#333333'"
                active-stroke="#8f6eb2"
                :active-count="(parseInt(exclusiveDetails.expire_in)/parseInt(exclusiveDetails.expire_days))*100"
                :reverse="false"
                :text="''">
              </circle-counter>
              <h3>{{exclusiveDetails && exclusiveDetails.expire_in}}</h3>
            </div>
            <h4>DAYS LEFT AS AN <br />EXCLUSIVE MEMBER</h4>
          </div>
          <div v-if="exclusiveDetails.expire_in < exclusiveDetails.renewal_reminder" class="exmembership-saving exmembership-extend-now">
            <h4>
              EXTEND YOUR PLAN
            </h4>
            <div class="d-flex justify-content-between">
              <h5>
                12 Months @<sup>{{ currencySymbol }}</sup>99 &nbsp;<span style="text-decoration: line-through; color: #959498;"><sup>{{ currencySymbol }}</sup>199</span>
              </h5>
              <h6>Save 50%</h6>
            </div>
          </div>
          <div v-if="exclusiveDetails.expire_in < exclusiveDetails.renewal_reminder" @click="upgradeMembershipToCart(EXCLUSIVE_PRODUCTS_UPGRADE.prod_id)" class="exmembership-extend-btn">Extend Now</div>
          <div v-else @click="goToHomepage()" class="exmembership-extend-btn exmembership-shop-btn">Shop Now</div>
          <div class="exmembership-features container">
            <h3>Your Benefits</h3>
            <div class="row">
              <div class="col-md-6 d-flex mb-5">
                <div class="features-img">
                  <img src="../assets/images/membership-icon1.png" alt="Big Dicsount" />
                </div>
                <div class="features-content">
                  <h4>Big Discounts</h4>
                  <h5>All products at discounted prices throughout the year.</h5>
                </div>
              </div>
              <div class="col-md-6 d-flex mb-5">
                <div class="features-img">
                  <img src="../assets/images/membership-icon2.png" alt="Early Access" />
                </div>
                <div class="features-content">
                  <h4>Early Access</h4>
                  <h5>Early access to products and community events just for you.</h5>
                </div>
              </div>
              <div class="col-md-6 d-flex mb-5">
                <div class="features-img">
                  <img src="../assets/images/membership-icon3.png" alt="Priority Shipping" />
                </div>
                <div class="features-content">
                  <h4>Priority Shipping</h4>
                  <h5>Enjoy free and priority shipping.</h5>
                </div>
              </div>
              <div class="col-md-6 d-flex mb-5">
                <div class="features-img">
                  <img src="../assets/images/membership-icon4.png" alt="Birthday Discount" />
                </div>
                <div class="features-content">
                  <h4>Birthday Discount</h4>
                  <h5>Flat 10% off on one order in your birthday month* *starting February 2024</h5>
                </div>
              </div>
              <div class="col-md-6 d-flex joyful">
                <div class="features-img">
                  <img src="../assets/images/membership-icon5.png" alt="Joyful Wednesdays" />
                </div>
                <div class="features-content">
                  <h4>Joyful Wednesdays</h4>
                  <h5>Stand a chance to win freebies every Joyful Wednesday.</h5>
                </div>
              </div>
            </div>
          </div>
          <div class="exmembership-applicable">Applicable on our site, app and offline store</div>
          <div class="faq-content-wrapper pt-3" v-if="exclusiveFaqsData && Object.keys(exclusiveFaqsData).length">
            <div class="faq-content-header recomm-header">
              FAQs
            </div>
            <div class="faq-content-data exclusive-faq-content">
                <exclusive-faqs :exclusiveFaqsData="exclusiveFaqsData"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="newRevamp">
      <div class="saveBigBanner d-flex flex-column" :style="isDesktop ? { backgroundImage: 'url(' + staticImg + 'exclusive/exclusive_background_web.jpg)' } : { backgroundImage: 'url(' + staticImg + 'exclusive/exclusive_background_mobile.jpg)' }">
          <div class="saveBigText pt-5 mt-4">
              <svg xmlns="http://www.w3.org/2000/svg" id="Group_1557" width="240.056" height="102.157" viewBox="0 0 220.056 82.157">
                  <path id="Path_1043" d="M-220.694 162.314c0-3.515-1.427-4.939-4.569-4.939h-2.837v9.925h2.735c3.778 0 4.671-1.535 4.671-4.986z" class="cls-1" transform="translate(377.509 -149.049)"/>
                  <path id="Path_1044" d="M-327.113 158.431h-.338c-.436 4.284-1.528 11.373-2.584 17.892h5.478c-1.013-6.516-1.992-13.785-2.556-17.892z" class="cls-1" transform="translate(375.779 -149.031)"/>
                  <path id="Path_1045" d="M-220.043 180.653c0-4.507-1.329-6.433-5.423-6.433h-2.634v12.606h3.243c3.165 0 4.814-1.507 4.814-6.173z" class="cls-1" transform="translate(377.509 -148.763)"/>
                  <path id="Path_1046" d="M-359.177 187.933c-3.066 0-4.11-2.525-4.367-6.192h-10.128c.218 7.583 3.532 13.771 14.393 13.771 10.023 0 14.339-5.882 14.339-13.265 0-7.509-3.515-11.034-11.793-15.2-4.857-2.428-5.854-3.747-5.854-6.305 0-2.492 1.02-3.972 3.3-3.972 2.914 0 3.483 2.673 3.654 5.784h9.88c-.086-6.858-3.064-13.362-13.471-13.362-8.849 0-13.517 5.011-13.517 12.65 0 6.565 2.929 9.944 10.686 13.949 5.254 2.693 6.808 4.51 6.808 7.6.005 2.535-.953 4.542-3.93 4.542z" class="cls-2" transform="translate(375.038 -149.188)"/>
                  <path id="Path_1047" d="M-331.128 185.1h8.149l1.566 9.561h10.659l-8.923-44.662H-334.1l-8.811 44.662h10.263zm3.9-26.523h.338c.564 4.107 1.543 11.376 2.557 17.892h-5.478c1.051-6.522 2.142-13.611 2.579-17.895z" class="cls-2" transform="translate(375.56 -149.174)"/>
                  <path id="Path_1048" d="M-290.88 194.657l9.76-44.662h-10.591l-2.8 17.489c-.911 5.661-2.015 11.663-2.473 16.984h-.295c-.461-5.156-1.306-11.389-2.261-17.113l-2.927-17.361h-10.878l9.67 44.662z" class="cls-2" transform="translate(376.062 -149.174)"/>
                  <path id="Path_1049" d="M-252.816 186.37h-15.308v-10.642h13.524v-8.353h-13.523v-8.984h14.137v-8.4h-24.2v44.662h24.172z" class="cls-2" transform="translate(376.659 -149.174)"/>
                  <path id="Path_1050" d="M-209.382 181.4c0-6.633-3.334-9.453-6.536-10.729 2.773-1.019 5.326-3.635 5.326-9.214 0-7.378-4.461-11.464-12.464-11.464h-14.855v44.662h14.511c8.632.002 14.018-4.399 14.018-13.255zm-18.557-23.9h2.841c3.142 0 4.569 1.425 4.569 4.939 0 3.451-.893 4.981-4.676 4.981h-2.735zm0 29.737v-12.606h2.639c4.093 0 5.423 1.926 5.423 6.433 0 4.666-1.648 6.173-4.818 6.173z" class="cls-2" transform="translate(377.342 -149.174)"/>
                  <path id="Rectangle_1581" d="M0 0H10.263V44.662H0z" class="cls-2" transform="translate(172.805 0.82)"/>
                  <path id="Path_1051" d="M-176.438 195.511c3.509 0 6.839-.89 8.769-4.365a30.8 30.8 0 0 0 .373 3.525h7.543V169.1h-14.657v8.058h4.391v2.857c0 4.815-.931 7.426-4.048 7.426-3.69 0-4.6-4.013-4.6-14.752 0-10.392.932-15.4 4.757-15.4 3.39 0 3.693 3.2 3.8 5.375h10.27c-.11-3.482-1.12-13.46-13.738-13.46-9.746 0-15.853 5.717-15.853 23.413-.001 16.211 4.082 22.894 12.993 22.894z" class="cls-2" transform="translate(378.165 -149.188)"/>
                  <path id="Path_1052" d="M-177.773 211.585c-.152 1.147-.546 3.02-1 5.32h2.09c-.465-2.386-.836-4.129-1.031-5.32z" class="cls-2" transform="translate(378.346 -148.129)"/>
                  <path id="Path_1053" d="M-375.015 201.135v29.329h220.056v-29.329zm9.4 21.234c-2.684 0-3.992-1.955-3.992-6.567 0-4.5 1.521-6.308 4.093-6.308 2.715 0 4.01 2.008 4.01 6.334.004 4.557-1.236 6.541-4.108 6.541zm13.881-.215h-2.43c-2.661-7.344-3.134-8.666-3.3-9.238h-.018c.093 1.536.095 3.371.095 5.6v3.635h-2.009v-12.459h2.534c2.576 6.888 3.072 8.2 3.222 8.812h.018c-.107-1.5-.111-3.332-.111-5.374v-3.438h1.994zm11.686 0l-.621-3.136h-2.884l-.618 3.136h-2.229l2.886-12.463h2.9l2.917 12.463zm10.049 0h-6.282v-12.462h2.235v10.559h4.264zm7.974 0h-6.283v-12.462h2.235v10.559h4.264zm9.06-5.069h-1.335v5.069h-2.235v-12.462h3.749a3.379 3.379 0 0 1 3.6 3.708c-.002 2.407-1.4 3.686-3.776 3.686zm12.73 1.962v.5a14.571 14.571 0 0 0 .168 2.61h-2.159a10.3 10.3 0 0 1-.214-2.631v-.454c0-1.666-.383-2.229-1.792-2.229h-.956v5.314h-2.22v-12.465h3.817c2.266 0 3.549 1.181 3.549 3.406a2.8 2.8 0 0 1-1.615 2.837c.968.452 1.424 1.272 1.424 3.113zm5.921 3.321c-2.683 0-3.991-1.955-3.991-6.567 0-4.5 1.521-6.308 4.092-6.308 2.716 0 4.01 2.008 4.01 6.334.003 4.558-1.236 6.542-4.109 6.542zm9.3-.215h-3.075v-12.461h3.248c3.205 0 4.45 2.055 4.45 5.976 0 4.208-1.193 6.487-4.623 6.487zm14.339-3.839c0 2.237-.873 4.056-3.883 4.056-2.964 0-3.827-1.711-3.827-4.057v-8.623h2.238v8.575c0 1.021.253 2.232 1.625 2.232 1.327 0 1.612-1.021 1.612-2.218v-8.589h2.234zm6.005 4.054c-3.544 0-3.95-3.113-3.95-6.462 0-4.036 1.183-6.413 4.083-6.413 3.305 0 3.561 2.834 3.611 3.832h-2.207c-.035-.424-.064-1.94-1.44-1.94-1.4 0-1.741 1.716-1.741 4.568 0 2.349.234 4.555 1.68 4.555 1.33 0 1.437-1.5 1.492-1.982h2.223c-.054.631-.292 3.843-3.75 3.843zm12.361-10.724h-2.662v10.509h-2.235v-10.508h-2.663v-1.954h7.561zm4.752 10.722c-2.865 0-3.738-1.836-3.817-3.7h2.222c.108 1.032.522 1.943 1.662 1.943 1.1 0 1.506-.689 1.506-1.615 0-1.024-.5-1.62-2.08-2.372-2.135-1.014-2.97-1.91-2.97-3.762a3.207 3.207 0 0 1 3.538-3.364c2.8 0 3.5 1.9 3.532 3.519h-2.186c-.072-.712-.255-1.761-1.385-1.761-.883 0-1.277.574-1.277 1.42 0 .9.4 1.317 1.861 2 2.235 1.033 3.239 2.038 3.239 4.124.002 1.95-1.211 3.569-3.844 3.569zm7.631-.211h-2.25v-2.825h2.25zm10.393 0h-6.419v-12.463h6.392v1.954h-4.189v3.034h4v1.936h-4v3.619h4.491zm6.965 0h-2.6l-3.095-12.463h2.4l1.142 5.288c.361 1.658.706 3.5.855 4.805h.037c.15-1.265.606-3.128.955-4.76l1.1-5.333h2.335zm11.043 0h-6.419v-12.463h6.393v1.954h-4.189v3.034h4v1.936h-4v3.619h4.491zm9.169-3.107v.5a14.671 14.671 0 0 0 .168 2.61h-2.158a10.243 10.243 0 0 1-.215-2.631v-.454c0-1.666-.382-2.229-1.792-2.229h-.956v5.314h-2.219v-12.466h3.816c2.265 0 3.549 1.181 3.549 3.406a2.8 2.8 0 0 1-1.616 2.837c.968.452 1.426 1.272 1.426 3.113zm6.692-1.677a1.107 1.107 0 0 0-.072.42v4.364h-2.235v-4.411a.894.894 0 0 0-.087-.4l-3.14-7.65h2.493c.7 1.954 1.551 4.359 1.921 5.725.456-1.531 1.314-3.865 1.942-5.725h2.356zm11.325 4.784h-3.073v-12.463h3.246c3.207 0 4.451 2.055 4.451 5.976.003 4.208-1.19 6.487-4.621 6.487zm12 0l-.621-3.136h-2.883l-.618 3.136h-2.239l2.886-12.463h2.9l2.914 12.463zm6.989-4.364v4.364h-2.235v-4.411a.894.894 0 0 0-.087-.4l-3.14-7.65h2.492c.7 1.954 1.552 4.359 1.922 5.725.456-1.531 1.314-3.865 1.942-5.725h2.356l-3.177 7.679a1.106 1.106 0 0 0-.072.418zm4.708 4.366h-2.25v-2.825h2.25z" class="cls-2" transform="translate(375.015 -148.306)"/>
                  <path id="Path_1054" d="M-187.51 211.375h-.817v8.783h.8c1.744 0 2.344-1.312 2.344-4.655-.003-2.867-.536-4.128-2.327-4.128z" class="cls-2" transform="translate(378.184 -148.132)"/>
                  <path id="Path_1055" d="M-208.839 211.327h-1.261v3.534h1.046c1.347 0 1.874-.58 1.874-1.84a1.487 1.487 0 0 0-1.659-1.694z" class="cls-2" transform="translate(377.814 -148.133)"/>
                  <path id="Path_1056" d="M-365.69 211.211c-1.334 0-1.754 1.622-1.754 4.4 0 2.956.448 4.715 1.756 4.715 1.377 0 1.771-1.628 1.771-4.711 0-2.896-.419-4.404-1.773-4.404z" class="cls-2" transform="translate(375.144 -148.135)"/>
                  <path id="Path_1057" d="M-342.682 211.585c-.151 1.147-.546 3.02-1 5.32h2.092c-.465-2.386-.838-4.129-1.033-5.32z" class="cls-2" transform="translate(375.547 -148.129)"/>
                  <path id="Path_1058" d="M-295.58 211.211c-1.333 0-1.753 1.622-1.753 4.4 0 2.956.447 4.715 1.755 4.715 1.378 0 1.771-1.628 1.771-4.711 0-2.896-.419-4.404-1.773-4.404z" class="cls-2" transform="translate(376.334 -148.135)"/>
                  <path id="Path_1059" d="M-314.108 211.327h-1.209v3.8h1.089c1.239 0 1.787-.612 1.787-1.928 0-1.252-.644-1.872-1.667-1.872z" class="cls-2" transform="translate(376.028 -148.133)"/>
                  <path id="Path_1060" d="M-286.509 211.375h-.817v8.783h.8c1.744 0 2.344-1.312 2.344-4.655-.002-2.867-.534-4.128-2.327-4.128z" class="cls-2" transform="translate(376.504 -148.132)"/>
                  <path id="Path_1061" d="M-305.085 211.327h-1.266v3.534h1.047c1.346 0 1.874-.58 1.874-1.84a1.487 1.487 0 0 0-1.655-1.694z" class="cls-2" transform="translate(376.181 -148.133)"/>
              </svg>
              <h4 class="cls-2" v-if="isDesktop" :class="isDesktop ? 'pt-4' : 'pt-5'"><b>Fun Facts</b></h4>
              <carousel v-if="isDesktop" :per-page="1"
              :loop="true"
              :mouse-drag="true"
              :autoplay="true"
              :autoplayTimeout="3000"
              paginationActiveColor="#fff"
              paginationColor="#646769"
              :paginationSize="7"
              :paginationPadding="5"
              class="exc-cat-carousel pb-5">
                  <slide v-for="(value, index) in this.funFacts" :key="index" class="exc-cat-slider">
                  <div class="funFactsSeq">
                      <span v-html="value"></span>
                  </div>
                  </slide>
              </carousel>
              <div v-if="!isDesktop" class="funFactsSeqTextOnly pt-3 pb-3">
                <span style="color: #fff; !important" v-html="funFacts[0]"></span>
              </div>
          </div>
          <div class="container exclusive-features pt-2" v-if="!isDesktop">
            <div class="row">
              <div class="col-md-5 col-10">
                <div class="float-left pl-1">
                  <span class="fbold text-left pb-2" style="color: #fff !important; font-size: 0.95rem;border-bottom: solid 1px #e76a52;"> Membership Benefits
                    <img :data-src="staticImg + 'exclusive/Crown-without-border.png'" class="crownImg" alt="Crown"/>
                  </span>
                </div>
              </div>
            </div>
            <div class="row m-4">
              <div class="col-md-6 pb-3 col-12">
                <div class="row">
                  <div class="col-4 col-md-4 eximgDiv">
                    <img class="eximg pt-1" :data-src="staticImg + 'exclusive/icons-01.png'" alt="Big Discounts">
                  </div> 
                  <div class="col-8 col-md-7">
                    <p class="text-left fbold cHeading" style="color: #fff !important;">BIG DISCOUNTS</p>
                    <div class="line mb10"><div class="excBenefitCircle"></div></div>
                      <p class="text-left cDesc" style="color: #fff !important;">
                        Save big on ALL products every day. Why wait for a sale?
                      </p>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div class="row">
                  <div class="col-4 col-md-4 eximgDiv">
                    <img class="eximg ptc-1" :data-src="staticImg + 'exclusive/icons-03.png'" alt="Free Delivery">
                  </div>
                  <div class="col-8 col-md-7">
                    <p class="text-left fbold cHeading" style="color: #fff !important;">FREE DELIVERY</p>
                    <div class="line mb10"><div class="excBenefitCircle"></div></div>
                      <p class="text-left cDesc" style="color: #fff !important;">
                      Our shipping charges are on us.
                      </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row m-4">
              <div class="col-md-6 pb-3 col-12">
                <div class="row">
                  <div class="col-4 col-md-4 eximgDiv">
                    <img class="eximg pt-1" :data-src="staticImg + 'exclusive/icons-02.png'" alt="Early Access">
                  </div>
                  <div class="col-8 col-md-7">
                    <p class="text-left fbold cHeading" style="color: #fff !important;">EARLY ACCESS</p>
                    <div  class="line mb10"><div class="excBenefitCircle"></div></div>
                      <p class="text-left cDesc" style="color: #fff !important;">
                       Get your hands on select products and designs before others do.
                      </p>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div class="row">
                  <div class="col-4 col-md-4 eximgDiv">
                    <img class="eximg pt-1" :data-src="staticImg + 'exclusive/icons-04.png'" alt="Prioritised Shipping">
                  </div>
                  <div class="col-8 col-md-7">
                    <p class="text-left fbold cHeading" style="color: #fff !important;">PRIORITISED SHIPPING</p>
                    <div  class="line mb10"><div class="excBenefitCircle"></div></div>
                      <p class="text-left cDesc" style="color: #fff !important;">
                      We ship your orders before everyone else’s.
                      </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
      <BannerPlaceHolderMsg
          v-if="$parent.bannerPlaceHolderExc && $parent.bannerPlaceHolderExc.status" 
          :bannerStyle="$parent.bannerPlaceHolderExc && $parent.bannerPlaceHolderExc.styles"
          :bannerMsg="$parent.bannerPlaceHolderExc && $parent.bannerPlaceHolderExc.text"
          callerComp='exc-revamp'
        >
      </BannerPlaceHolderMsg>
      <div class="container mt40 exclusive-features" v-if="isDesktop">
          <div class="row justify-content-center">
            <div class="col-md-5 col-10 text-center">
              <div class="exc-mem-heading">
                <span class="fbold text-left benefitsHeading"> Membership Benefits
                  <img :data-src="staticImg + 'exclusive/Crown-without-border.png'" class="crownImg" alt="Crown"/>
                </span>
              </div>
            </div>
          </div>
          <div class="row mt-0 ml-5 mr-5">
            <div class="col-md-6 col-12">
              <div class="row">
                <div class="col-4 col-md-4 eximgDiv">
                  <img class="eximg" :data-src="staticImg + 'exclusive/icons-01.png'" alt="Big Discounts">
                </div> 
                <div class="col-8 col-md-7">
                  <p class="text-left fbold cHeading">BIG DISCOUNTS</p>
                  <div class="line mb10"><div class="excBenefitCircle"></div></div>
                    <p class="text-left cDesc">
                      Save big on ALL products every day. Why wait for a sale?
                    </p>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-12">
              <div class="row">
                <div class="col-4 col-md-4 eximgDiv">
                  <img class="eximg" :data-src="staticImg + 'exclusive/icons-02.png'" alt="Early Access">
                </div>
                <div class="col-8 col-md-7">
                  <p class="text-left fbold cHeading">EARLY  ACCESS</p>
                  <div class="line mb10"><div class="excBenefitCircle"></div></div>
                    <p class="text-left cDesc">
                    Get your hands on select products and designs before others do.
                    </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row m-5">
            <div class="col-md-6 col-12">
              <div class="row">
                <div class="col-4 col-md-4 eximgDiv">
                  <img class="eximg" :data-src="staticImg + 'exclusive/icons-03.png'" alt="Free Delivery">
                </div>
                <div class="col-8 col-md-7">
                  <p class="text-left fbold cHeading">FREE DELIVERY</p>
                  <div  class="line mb10"><div class="excBenefitCircle"></div></div>
                    <p class="text-left cDesc">
                      Our shipping charges are on us.   
                    </p>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-12">
              <div class="row">
                <div class="col-4 col-md-4 eximgDiv">
                  <img class="eximg" :data-src="staticImg + 'exclusive/icons-04.png'" alt="Prioritised Shipping">
                </div>
                <div class="col-8 col-md-7">
                  <p class="text-left fbold cHeading">PRIORITISED SHIPPING</p>
                  <div  class="line mb10"><div class="excBenefitCircle"></div></div>
                    <p class="text-left cDesc">
                    We ship your orders before everyone else’s.
                    </p>
                </div>
              </div>
            </div>
          </div>
      </div>
      <div class="exc-section-two-wrapper">
          <div  class="exc-section-two">
              <ExclusiveCard v-if="!isExclusive" :isDesktop="isDesktop" :addMembershipToCart="addMembershipToCart" :addExclusive="addExclusive"></ExclusiveCard>
              <div v-if="isExclusive && !exclusiveUser" class="exclusive-congrats-msg">Congratulations, You're a member!</div>
          </div>
      </div>
      <TestimonialsSlider :isDesktop="isDesktop" :testimonials="testimonials"></TestimonialsSlider>
      <div class="faq-content-wrapper pt-3" v-if="!isDesktop && exclusiveFaqsData && Object.keys(exclusiveFaqsData).length">
        <div class="faq-content-header recomm-header">
          FAQs
        </div>
        <div class="faq-content-data exclusive-faq-content">
            <exclusive-faqs :exclusiveFaqsData="exclusiveFaqsData"/>
        </div>
      </div>
    </div>
  </div> 
</template>
<script>
var $ = require('jquery')
window.jQuery = $
import BannerPlaceHolderMsg from './common/BannerPlaceHolderMsg'
import ExclusiveCatCards from './common/excCategoryCard.vue'
import ExclusiveCard from '../components/common/ExclusiveCard'
import TestimonialsSlider from './common/TestimonialsSlider'
import circleCounter from 'vue-circle-counter'
import exclusiveFaqs from '../components/faqsContent/exclusiveFaqs'
import {mapGetters} from 'vuex'
import Vue from 'vue'
export default {
  data: function () {
    return {
      staticImg: process.env.STATIC_IMG_SERVER2,
      testimonials: [
        {
          comment: 'The membership has definitely been worth the value. I\'ve never had a bad experience with the membership and all these continuous discounts are very beneficial to the customer.',
          commentBy: 'Bhuvandeep, Bangalore',
          rating: 4
        },
        {
          comment: 'The membership is great, it helps save so much money. You not only recover the money you\'ve spent on it, but save so much more!',
          commentBy: 'Atharva, Pune',
          rating: 5
        },
        {
          comment: 'The membership has been a real blessing, it gives you first preference for limited edition clothes, it also helps you save so much and it barely costs anything in comparison with what you save.',
          commentBy: 'Rahul, Pune',
          rating: 4
        }
      ],
      isDesktop: this.$parent.$parent.isDesktop
    }
  },
  components: {
    BannerPlaceHolderMsg,
    ExclusiveCard,
    TestimonialsSlider,
    circleCounter,
    ExclusiveCatCards,
    exclusiveFaqs
  },
  methods: {
    addMembershipToCart  (item) {
      if (!this.isExclusive) {
        let _this = this
        this.$store.dispatch('UPDATE_CART', {type: 'products', operation: 'set', route: _this.$route.fullPath, data: {prod_id: item, quantity: 1, categories: []}}).then(() => {
          // _this.$store.commit('GTAG_EVENT', {eventName: 'exc.membership.added.exc.landing', payload: {exclusive_tracker: this.$route.path}})
          // this.$store.dispatch('TATVIC_EVENT', {eventName: 'ADD_MEMBERSHIP_TO_CART',
          //   payload: {
          //     exclusive_tracker: this.$route.path
          //   }}
          // )
          let alertConfig = {
            html: true,
            okText: 'Continue Shopping',
            animation: 'fade',
            customClass: 'exclusive-revamp'
          }
          this.$dialog.alert('<div class="congratulation fbold text-center">Congratulations!!!</div><div class="text-center mt10 mt-4">We\'ve added The Souled Store Membership extension to your cart at the discounted price.</div>', alertConfig)
          .then(function () {
            _this.$router.push('/')
          })
          _this.toggleExclusiveBar()
        })
      } else {
        Vue.toasted.show('Already added to cart', {theme: 'primary', className: 'toasted-customred', position: 'top-right', duration: 5000})
      }
    },
    addExclusive (item) {
      if (!this.isExclusive) {
        let _this = this
        this.$store.dispatch('UPDATE_CART', {type: 'products', operation: 'set', route: _this.$route.fullPath, data: {prod_id: item, quantity: 1, categories: []}}).then(() => {
          _this.toggleExclusiveBar()
          this.exclusiveAdded = true
        })
      } else {
        Vue.toasted.show('Already added to cart', {theme: 'primary', className: 'toasted-customred', position: 'top-right', duration: 5000})
      }
    },
    toggleExclusiveBar () {
      if (Vue.ls.get('exclusive') !== 1) {
        let $exclusiveElement = $('.exclusive-topbar')
        $exclusiveElement.slideDown()
        $exclusiveElement.find('.close').on('click', function () {
          $('.navbar-toggleable-md').removeClass('exclusive-fixed')
          $exclusiveElement.slideUp()
          Vue.ls.set('exclusive', 1, 30 * 60 * 1000)
        })
      }
    },
    upgradeMembershipToCart (item) {
      let _this = this
      this.$store.dispatch('TATVIC_EVENT', {eventName: 'RENEW_EXCLUSIVE_MEMBERSHIP',
        payload: {
          DAYS_LEFT: this.exclusiveDetails && this.exclusiveDetails.expire_in,
          ACTIVE_PLAN: this.exclusiveDetails.membership_type === 'MONTHLY' ? '1 Month' : this.exclusiveDetails.membership_type === 'ANNUAL' ? '12 Months' : '3 Months'
        }}
      )
      if (!this.CHECK_PRODUCT_MATCHES) {
        this.$store.dispatch('UPDATE_CART', {type: 'products', name: 'Exclusive', operation: 'set', route: _this.$route.fullPath, data: {prod_id: parseInt(item), quantity: 1, categories: []}}).then((res) => {
        })
      } else {
        Vue.toasted.show('Already added to cart', {theme: 'primary', className: 'toasted-customred', position: 'top-right', duration: 5000})
      }
    },
    goToHomepage () {
      this.$router.push('/')
    }
  },
  computed: {
    ...mapGetters(['isExclusive', 'exclusiveUser', 'notify', 'site_config', 'exclusivePricelist', 'username', 'user', 'exclusiveDetails', '_cart', 'isLoading', 'bannerPlcaeHolderData', 'authStatus', 'faqs', 'memberSavingsTxt', 'currencySymbol', 'isSelectedCountryIndia']),
    CHECK_PRODUCT_MATCHES: function () {
      let excProduct = this._cart.products.items.find(item => item.category === 'Exclusive')
      if (excProduct) {
        let matchProductId = this.site_config.exclusive_products_upgrade.some(upgradeItem => parseInt(upgradeItem.prod_id) === excProduct.parent_prod_id)
        return matchProductId
      }
      return false
    },
    EXCLUSIVE_PRODUCT: function () {
      return this.site_config.exclusive_product
    },
    EXCLUSIVE_PRODUCTS_UPGRADE: function () {
      // if (this.exclusiveDetails.expire_days <= 31) {
      //   return this.site_config.exclusive_products_upgrade.find(upgradeProduct => upgradeProduct.duration > 320)
      // }
      // if (this.exclusiveDetails.expire_days > 31 && this.exclusiveDetails.expire_days <= 90) {
      //   return this.site_config.exclusive_products_upgrade.find(upgradeProduct => upgradeProduct.duration >= 270 && upgradeProduct.duration < 300)
      // }
      if (this.exclusiveDetails) {
        return this.site_config.exclusive_products_upgrade.find(upgradeProduct => upgradeProduct.duration === 365)
      }
    },
    exclusiveFaqsData () {
      return this.faqs && this.faqs.length && this.faqs.find(faq => faq && faq.hide_menu && faq.name && faq.name.toLowerCase() && faq.name.toLowerCase().includes('exclusive web'))
    },
    formatTimesResult () {
      let result = this.exclusiveDetails.exclusive_savings / 200
      if (result % 1 === 0) {
        return result.toFixed(0)
      } else {
        return result.toFixed(1)
      }
    },
    funFacts () {
      return [
        `Add the membership to your cart<br> and get the discount on this order itself.`,
        `Most people save the membership fee on their first order.`,
        `The average member SAVES ${this.currencySymbol}2,600/year.`,
        `Most people become members and don’t pay full price.`
      ]
    }
  },
  mounted () {
    // this.$store.commit('SNAPTR_EVENTS', {
    //   userEmail: this.authStatus ? Vue.ls.get('email') : '',
    //   pageView: true
    // })
  },
  created () {
    this.faqs && this.faqs.length ? '' : this.$store.dispatch('GET_FAQS')
  }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nunito&family=Open+Sans:wght@400;600;700&display=swap');
@font-face {
  font-family: "Phonk Regular DEMO";
  src: url("../assets/font/PhonkRegularDemo.woff")format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
.exmembership-wrapper h2,
.exmembership-wrapper h3,
.exmembership-wrapper h4,
.exmembership-wrapper h5 {
  margin: 0;
  font-weight: inherit;
}
.exmembership-header {
  font-family: "Phonk Regular DEMO";
  padding: 25px 15px;
  color: #000
}
.exmembership-header h3 {
  font-size: 32px;
}
.exmembership-header h2 {
  font-size: 48.5px;
  margin-top: -8px;
}
.exmembership-content {
  background-image: 
    url('../assets/images/membership-bg-back.png'),
    url('../assets/images/membership-bg.png');
  background-size: 100% auto;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  padding: 50px 15px;
}
.exmembership-heading {
  margin-bottom: 45px;
}
.exmembership-heading h3 {
  font-size: 48px;
}
.exmembership-heading h4 {
  font-size: 18px;
  margin-top: 8px;
}
.exmembership-saving {
  width: 500px;
  display: inline-block;
  background: url("../assets/images/saving-border.png") no-repeat;
  background-size: 500px 108px;
  border-radius: 10px;
  position: relative;
  padding: 20px 15px;
}
.exmembership-saving h4 {
  font-size: 22px;
  position: absolute;
  left: 50%;
  top: -15px;
  transform: translateX(-50%);
}
.exmembership-saving h3 span {
  font-family: "Phonk Regular DEMO";
  font-weight: normal;
  font-size: 62px;
}
.exmembership-saving h3 sup {
  position: relative;
  left: -4px;
  top: -15px;
  font-size: 20px;
  font-weight: 400;
}
.exmembership-saving-heading {
  margin: 20px 0 60px;
}
.exmembership-saving-heading h5 {
  font-size: 20px;
}
.exmembership-saving-heading h4 {
  font-size: 22px;
}
.exmembership-day-left {
  text-align: center;
}
.exmembership-day-inner {
  position: relative;
  display: inline-block;
}
.exmembership-day-left h3 {
  font-size: 60px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.exmembership-day-left h4 {
  font-size: 22px;
  margin-top: 5px;
}
.exmembership-extend-now {
  margin: 70px 0 25px;
  padding: 30px 15px;
  background-size: 500px 82px;
}
.exmembership-extend-now h4 {
  font-weight: 600;
}
.exmembership-extend-now h5 {
  font-size: 22px;
}
.exmembership-extend-now h5 sup {
  top: -3px;
}
.exmembership-extend-now h6 {
  font-size: 20px;
  margin: 3px 0 0;
}
.exmembership-extend-btn {
  width: 240px;
  text-align: center;
  color: #3f3f3f;
  border-radius: 10px;
  padding: 10px 30px;
  font-size: 20px;
  text-transform: uppercase;
  background: url("../assets/images/membership-gradient.png");
  background-size: cover;
  cursor: pointer;
}
.exmembership-shop-btn {
  margin-top: 40px;
}
.exmembership-features {
  text-align: left;
  margin-top: 70px;
}
.exmembership-features h3 {
  width: 50%;
  font-size: 28px;
  margin: 0 auto 40px;
  text-align: center;
  padding-bottom: 10px;
  border-bottom: 2px solid #fff;
}
.exmembership-features .features-img {
  width: 120px;
  margin: 5px 20px 0 0;
}
.exmembership-features h4 {
  font-size: 24px;
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: 2px solid #fff;
  position: relative;
}
.exmembership-features h4:before {
  width: 8px;
  height: 8px;
  display: inline-block;
  content: "";
  border-radius: 50%;
  background: #fff;
  position: absolute;
  left: 0;
  bottom: -5px;
}
.exmembership-features .features-content {
  padding-right: 30px;
  flex: 1;
}
.exmembership-features h5 {
  font-weight: 400;
  font-size: 16px;
  line-height: 1.25;
}
.exmembership-features .joyful {
  margin: 0 auto;
}
.exmembership-features .joyful .features-img {
  width: 170px;
  margin-top: 15px;
}
.exmembership-applicable {
  width: 100%;
  padding: 5px 10px;
  font-size: 22px;
  text-transform: uppercase;
  background: url("../assets/images/membership-gradient.png");
  background-size: cover;
  color: #000;
  margin: 60px 0 50px;
}
.exclusive-congrats-msg {
  padding: 0px 0px 35px 0px !important;
}
.cls-1{fill:none}
.cls-2{fill:#fff;color: #fff;}
.saveBigBanner {
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.benefitsHeading {
  color: #161b24 !important;
  letter-spacing: normal;
}
.funFactsSeq {
  border-color: #fff;
  border-radius: 0.3rem;
  color:#fff;
  border-width: 1px;
  border-color: #fff;
  border-style: double;
  padding: 1.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.exc-cat-slider {
  padding: 0!important;
}
.cDesc {
  color: #161b24;
  font-size: 18px;
}
.cHeading {
  font-size: 26px;
  color: #122643;
}
.exc-mem-heading {
  display: inline-block;
  border-bottom: 2px solid #e76a52;
}
.eximg {
  width: 70%;
}
.userHead {
  padding: 0 !important;
  font-size: 29px !important;
}
.total-savings-div {
  background: transparent !important;
}

.total-savings {
  color: #e66a51 !important;
  padding: 0 !important;
  font-size: 30px !important;
}
.exc-mem-info {
  padding: 0px 15px 0px 15px !important;
}
.crownImgMain {
  width: 45px;
  margin-left: 0px;
  height: 48px;
  margin-bottom: 16px;
}
.exc-days-left-head {
  color: #161b24 !important;
  font-size: 26px !important;
}
.exc-days-left {
  color: #e66a51 !important;
}
.days-left {
  color: #e66a51 !important;
}
.exc-active-plan {
 font-size: 23px !important;
 letter-spacing: normal;
}
.exc-member-since {
 font-size: 23px !important;
 letter-spacing: normal;
}
.exc-mem-section-one {
  background-color: #f9f9f9 !important;
}
.exc-mem-exceede-time {
  color: #161b24 !important;
  text-transform: none !important;
  font-size: 21px !important;
  font-family: OpenSans-Semibold !important;
}
.offer-tile {
  color: #161b24 !important;
  font-style: italic;
  font-size: 14px;
}
.exc-mem-update-div {
  padding: 12px 5px 12px 5px !important;
}
.btn-renew {
  background: #e66a51 !important;
  color: #fff !important;
}
.recomm-header{
  color: #161b24;
  font-size: 26px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
}
.renewal-wrapper {
  display: flex;
  align-items: center;
}
.exc-mem-extend-time {
  color: #1a1f29;
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  letter-spacing: 0;
}
.exclusive-price-offer {
    color: #e76a52;
    text-align: left;
    font-weight: 600;
    font-size: 19px;
    line-height: 22px;
    letter-spacing: 0;
}
.exc-mem-update-btn {
    display: inline;
    background-color: #e76a52;
    border-color: #e9e3e3;
    border-width: 1px;
    border-style: solid;
    width: inherit;
    padding: 10px;
    border-radius: 5px;
    color: #fff;
}
@media screen and (max-width: 767px) {
  .exmembership-content {
    background-size: cover;
  }
  .exmembership-header h3 {
    font-size: 22px;
  }
  .exmembership-header h2 {
    font-size: 33px;
  }
  .exmembership-content {
    padding: 30px 15px;
  }
  .exmembership-heading h3 {
    font-size: 30px;
  }
  .exmembership-heading h4 {
    font-size: 16px;
  }
  .exmembership-saving {
    width: 330px;
    background-size: 330px 95px;
  }
  .exmembership-saving-heading h5 {
    font-size: 14px;
  }
  .exmembership-saving-heading h4 {
    font-size: 16px;
  }
  .exmembership-saving h3 {
    font-size: 50px;
  }
  .exmembership-saving h4 {
    font-size: 18px;
    top: -11px;
  }
  .exmembership-day-left h4{
    font-size: 20px;
  }
  .exmembership-extend-now {
    background-size: 330px 76px;
  }
  .exmembership-extend-now h4 {
    font-size: 16px;
    top: -8px;
    width: 100%;
  }
  .exmembership-extend-now h5 {
    font-size: 16px;
  }
  .exmembership-extend-now h6 {
    font-size: 16px;
    margin: 0;
  }
  .exmembership-features h3 {
    width: 70%;
    font-size: 18px;
  }
  .exmembership-features .features-content {
    padding-right: 0;
  }
  .exmembership-features h4 {
    font-size: 16px;
  }
  .exmembership-features h5 {
    font-size: 14px;
  }
  .exmembership-features[data-v-667ed8aa] {
    margin-top: 50px;
    padding: 0;
  }
  .exmembership-features .features-img,
  .exmembership-features .joyful .features-img {
    width: 80px;
  }
  .exmembership-applicable {
    width: 100vw;
    margin: 40px -15px 30px;
    font-size: 14px;
  }
}

@media only screen and (max-width: 320px) {
  .ptc-1 {
    padding-top: 0.25rem !important;
  }
  .btn-renew[data-v-2d0f9420] {
    font-size: 9px;
    padding: 5px;
  }
  .exc-mem-exceede-time {
    font-size: 8px!important;
  }
  .btn-renew {
    padding: 5px;
    font-size: 8px;
  }
}

@media only screen and (max-width: 480px) {
  .cDesc {
  color: #161b24;
  font-size: 0.7rem;
  }
  .cHeading {
    font-size: 14px;
    margin-bottom: 5px;
    color: #122643;
  }
  .funFactsSeqTextOnly {
    font-family: 'Source Sans Pro semibold', sans-serif !important;
    letter-spacing: normal;
    font-weight: 600;
  }
  .exc-mem-name {
    font-size: 1.1rem !important;
  }
  .exc-active-plan {
    font-size: 0.8rem !important;
    font-family: 'Source Sans Pro semibold', sans-serif !important;
    font-weight: 600;
    letter-spacing: normal;
  }
  .exc-member-since {
    font-size: 0.8rem !important;
    border-bottom: 2px solid #e6e5e5 !important;
    padding-bottom: 2.3rem !important;
    font-family: 'Source Sans Pro semibold', sans-serif !important;
    font-weight: 600;
    letter-spacing: normal;
  }
  .total-savings {
    font-size: 14px !important;
    letter-spacing: 0px;
    -webkit-text-stroke: 0.4px #f9f9f9;
    -webkit-font-smoothing: antialiased;
    line-height: 19px;
    font-weight: inherit;
    color: #ffffff !important;
  }
  .crownImgMain {
    margin-bottom: 0.1rem;
    height: 40px;
    width: 36px;
  }
  .total-savings-div {
    display: flex !important;
    justify-content: center !important;
    width: 100% !important;
    background-color: #e76a52!important;
  }
  .exc-days-left {
    top: 10px;
  }
  .days-left {
    top: 64px;
  }
  .exc-days-left-head {
    font-size: 1rem !important;
    border-bottom: 0px !important;
    letter-spacing: normal !important;
  }
  .extend-mem-mobile {
    background: #ffffff;
    margin: 15px;
    border: 1px solid rgba(100, 103, 105, 0.4);
    border-radius: 8px;
    justify-content: center;
    align-items: center;
  }
  .extend-mem-mobile .header {
    position: absolute;
    margin-left: 10px;
    background: #ffffff;
    border-radius: 10px;
    padding: 2px 10px;
    margin-top: -66px;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 12px;
    line-height: 30px;
  }
  .exc-mem-exceede-time {
    color: #e76a52 !important;
    font-size: 12px !important;
    text-align: inherit !important;
    line-height: 16px;
    letter-spacing: 0;
    font-weight: 600;
  }
  .offer-tile {
    font-size: 9px;
    color: #148c8d !important;
    font-style: normal;
    font-weight: 600;
  }
  .btn-renew {
    border-radius: inherit;
    font-size: 9px;
    margin-bottom: 5px;
    line-height: 18px;
  }
  .benefitsHeading {
    color: #161b24 !important;
    border-bottom:0 !important;
    font-weight: 600;
    font-style: normal;
    letter-spacing: 0.7px;
    font-size: 1rem;
    -webkit-font-smoothing: antialiased;
  }
  .recomm-header{
    font-size: 1rem;
    letter-spacing: 0px;
  }
  .line {
    background: #fff !important;
  }
  .excBenefitCircle {
    background: #fff !important;
  }
  .line2 {
    background-color: #122643 !important;
  }
  .excBenefitCircle2 {
    background-color: #122643 !important;
  }
  .funFactsSeq {
    width: 90%;
  }
  .exc-active-plan, .exc-member-since {
    height: 20px !important;
    -webkit-font-smoothing: antialiased;
    -webkit-text-stroke: 0.4px #f9f9f9;
    color: #000;
  }
  .exclusive-congrats-msg {
    padding: 30px 0px 30px 0px !important;
  }
}

@media only screen and (min-width: 800px) {
  .extend-mem-mobile {
    background: #ffffff;
    margin: 15px;
    border: 1px solid rgba(100, 103, 105, 0.4);
    border-radius: 8px;
    justify-content: center;
    align-items: center;
  }
  .extend-mem-mobile .header {
    position: absolute;
    margin-left: 10px;
    background: #ffffff;
    border-radius: 10px;
    padding: 2px 10px;
    margin-top: -66px;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 12px;
    line-height: 30px;
  }
}
</style>
<style>
.exmembership-content .faq-content-wrapper .recomm-header {
  color: #fff;
}
.exmembership-content .faq-content-data .exc-grey {
  color: #fff;
  font-size: 16px;
}
.exmembership-content .faq-content-data .exc-grey-content {
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 0;
}
.exmembership-content .faq-content-data li {
  border-color: #e2e2e2 !important
}
.exmembership-content .faq-content-data li i:before,
.exmembership-content .faq-content-data li i:after {
  background-color: #e2e2e2;
}
.exmembership-content .exclusive-faq-content .container {
  width: 100%;
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// exclusive-revamp.vue?b23bb1ec